<template>
  <div>
    <div class="info">
      <div class="title">Management Team</div>
      <div class="grid">
        <div class="grid__row" v-for="(row, rowIndex) in array" :key="rowIndex">
          <div
            class="grid__column"
            v-for="(column, columnIndex) in row"
            :key="columnIndex"
          >
            <img class="grid__column__img" :src="column.photo" />
            <div class="grid__column__name">{{ column.name }}</div>
            <div class="grid__column__position" v-html="column.position"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="staff">
      <div class="staff__title">AC Orange Staff</div>
      <div class="staff__content" v-html="staffDesc"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      staffDesc: `
      More than 500 young talents<br/>
      International team from USA, Japan, Korea and China<br/>
      The average age of 29 years old<br/>
      Excellence & profession<br/>
      Live · Art · Inspiration`,
      array: [
        [
          {
            name: "John Geng",
            position: "Chairman",
            photo: require("../../assets/team_1.png")
          },
          {
            name: "Yi Wang",
            position: "Rotating CEO",
            photo: require("../../assets/team_2.png")
          },
          {
            name: "Kuan Jiang",
            position:
              "President<br/>Executive Director<br/>Chairman of WantU Music",
            photo: require("../../assets/team_3.png")
          },
          {
            name: "Haocheng Cao",
            position: "Executive Director<br/>GM ACO Pop",
            photo: require("../../assets/team_4.png")
          },
          {
            name: "Echo Liu",
            position: "Executive Director ",
            photo: require("../../assets/team_5.png")
          }
        ],
        [
          {
            name: "Flora Hu",
            position: "Vice President<br/>GM Little<br/>Orange Castle",
            photo: require("../../assets/team_6.png")
          },
          {
            name: "Lei Wang",
            position: "Vice-President<br/>GM Orange<br/>Theaters Unit",
            photo: require("../../assets/team_7.png")
          },
          {
            name: "Zhipeng Pan",
            position: "Vice-President",
            photo: require("../../assets/team_8.png")
          },
          {
            name: "Tina Shao  ",
            position: "Vice-President<br/>GM WantU Music",
            photo: require("../../assets/team_9.png")
          },
          {
            name: "Yue Tang",
            position: "Finance Director",
            photo: require("../../assets/team_10.png")
          }
        ]
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 1200px;
  margin: 72px auto 0 auto;
  .title {
    line-height: 31px;
    height: 31px;
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: rgba(46, 41, 37, 1);
  }
}
.grid {
  margin-top: 54px;
  &__row {
  }
  &__column {
    height: 421px;
    display: inline-block;
    width: 230px;
    margin-left: 10px;
    vertical-align: top;
    &__img {
      display: block;
    }
    &__name {
      font-size: 24px;
      color: #232323;
      text-align: center;
      font-weight: bold;
      height: 27px;
      line-height: 27px;
      margin-top: 21px;
    }
    &__position {
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      margin-top: 7px;
    }
  }
}
.staff {
  height: 389px;
  background-color: #ff9000;
  background-image: url("../../assets/team_bg.png");
  background-position: center;
  overflow: hidden;
  &__title {
    margin-top: 60px;
    height: 33px;
    font-size: 30px;
    line-height: 33px;
    font-weight: 400;
    color: rgba(254, 254, 254, 1);
    text-align: center;
  }
  &__content {
    color: #fefefe;
    text-align: center;
    font-size: 22px;
    font-weight: 300;
    color: rgba(254, 254, 254, 1);
    line-height: 42px;
    margin-top: 25px;
  }
}
</style>